import React from 'react';
import { Grid, TextField, MenuItem } from '@mui/material';

class FormFields extends React.Component {
    render() {
        const { form, updateFormState, inputClass, labelClass } = this.props;

        // Ensure default values for new attributes
        const stayType = form.type_of_stay || 'night';
        const adults = form.adults_count || 0;
        const children = form.children_count || 0;
        const tents = form.tents_count || 0;

        return (
            <>
                <Grid item xs={12}>
                    <label className={labelClass}>Typ pobytu</label>
                    <select
                        name="type_of_stay"
                        className={inputClass}
                        value={stayType}
                        onChange={(e) => updateFormState(e.target.value, 'type_of_stay')}
                    >
                        <option value="day">Denný</option>
                        <option value="night">Nočný</option>
                    </select>
                </Grid>
                <Grid item xs={4}>
                    <label className={labelClass}>Dospelí</label>
                    <input
                        type="number"
                        name="adults_count"
                        className={inputClass}
                        value={adults}
                        onChange={(e) => updateFormState(e.target.value, 'adults_count')}
                    />
                </Grid>
                <Grid item xs={4}>
                    <label className={labelClass}>Deti</label>
                    <input
                        type="number"
                        name="children_count"
                        className={inputClass}
                        value={children}
                        onChange={(e) => updateFormState(e.target.value, 'children_count')}
                    />
                </Grid>
                <Grid item xs={4}>
                    <label className={labelClass}>Stany</label>
                    <input
                        type="number"
                        name="tents_count"
                        className={inputClass}
                        value={tents}
                        onChange={(e) => updateFormState(e.target.value, 'tents_count')}
                    />
                </Grid>
                <Grid item xs={4}>
                    <label className={labelClass}>Autá</label>
                    <input
                        type="number"
                        name="cars_count"
                        className={inputClass}
                        value={form.cars_count || 0}
                        onChange={(e) => updateFormState(e.target.value, 'cars_count')}
                    />
                </Grid>
                <Grid item xs={4}>
                    <label className={labelClass}>Karavany</label>
                    <input
                        type="number"
                        name="caravans_count"
                        className={inputClass}
                        value={form.caravans_count || 0}
                        onChange={(e) => updateFormState(e.target.value, 'caravans_count')}
                    />
                </Grid>
            </>
        );
    }
}

export default FormFields;
